import {
  Button,
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Checkbox,
  Tooltip,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import {
  useGetAllLeaveCategoryQuery,
  useGetAllLeaveSubCategoryByCategoryIdQuery,
} from 'src/app/services/leaveRequestApi';
import FuseSvgIcon from '@fuse/core/FuseSvgIcon';
import { useState } from 'react';
import SimpleDialog from '@fuse/core/SimpleDialog';
import AbsenceAsksSubCategoryForm from './AbsenceAsksSubCategoryForm';
import { Edit } from '@mui/icons-material';
import FuseLoading from '@fuse/core/FuseLoading';

const AbsenceAsksSubCategories = () => {
  const { t, i18n } = useTranslation('translations');
  const lang = i18n.language;
  const [subcategoryId, setSubcategoryId] = useState(null);
  const [categoryId, setCategoryId] = useState('');
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const { data: absenceAsksCategories = [] } = useGetAllLeaveCategoryQuery({ lang });
  const {
    data: subcategories = [],
    refetch,
    isLoading,
  } = useGetAllLeaveSubCategoryByCategoryIdQuery(
    { CategoryId: categoryId, lang },
    { skip: !lang || !categoryId }
  );

  const showAddDialog = () => {
    setSubcategoryId(null);
    setIsDialogOpen(true);
  };

  const showEditDialog = (id) => {
    setSubcategoryId(id);
    setIsDialogOpen(true);
  };

  const handleDialogClose = () => {
    setIsDialogOpen(false);
    refetch();
  };

  return (
    <div>
      {isLoading ? (
        <FuseLoading />
      ) : (
        <TableContainer>
          <div className="flex flex-col flex-wrap items-center justify-between gap-10 mt-10 md:flex-row">
            <h2 className="ml-5"> {t('AbsenceAsksSubCategories')}</h2>

            <div className="flex items-center gap-10">
              <div>
                <FormControl size="small" className="min-w-[150px]">
                  <InputLabel id="absence-ask-categories-label">{t('Category')}</InputLabel>
                  <Select
                    labelId="absence-ask-categories-label"
                    id="absence-ask-categories-select"
                    label={t('Category')}
                    value={categoryId}
                    onChange={(e) => setCategoryId(e.target.value)}
                    input={<OutlinedInput label={t('Column')} />}
                  >
                    {absenceAsksCategories.map((cat) => (
                      <MenuItem key={cat.id} value={cat.id}>
                        {cat.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </div>
            </div>
            <Button
              className="mx-10"
              size="small"
              variant="outlined"
              color="secondary"
              onClick={showAddDialog}
              disabled={!categoryId}
            >
              <FuseSvgIcon size={20}>react-outline:plus</FuseSvgIcon>
              <span className="mx-8">{t('Add')}</span>
            </Button>
          </div>
          <Table style={{ overflow: 'auto' }}>
            <TableBody className="overflow-y-auto ">
              {subcategories.map((item) => (
                <TableRow key={item.id} className="bg-white hover:bg-grey-200 dark:bg-dark">
                  <TableCell>{item.name}</TableCell>
                  <TableCell>
                    <div className="flex items-center">
                      <Tooltip title={t('IncludeInAttendanceReport')} arrow placement="top">
                        <span>
                          <Checkbox
                            checked={!!item.addToAttendanceReport}
                            disabled
                            color="secondary"
                          />
                        </span>
                      </Tooltip>

                      <IconButton
                        edge="end"
                        aria-label="edit"
                        className="mr-5"
                        color="info"
                        onClick={() => showEditDialog(item.id)}
                      >
                        <Edit />
                      </IconButton>
                    </div>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
      <SimpleDialog
        title={subcategoryId ? t('EditAbsenceAskSubcategory') : t('AddAbsenceAskSubcategory')}
        open={isDialogOpen}
        onClose={() => setIsDialogOpen(false)}
      >
        <AbsenceAsksSubCategoryForm
          id={subcategoryId}
          categoryId={categoryId}
          refetch={refetch}
          onClose={handleDialogClose}
          isEdit={!!subcategoryId}
        />
      </SimpleDialog>
    </div>
  );
};

export default AbsenceAsksSubCategories;
